export const dashboardData = {
  metrics: {
    activeBookings: {
      value: 24,
      previousPeriod: 22,
      change: "+8%",
      isPositive: true,
    },
    occupancyRate: {
      value: 76,
      previousPeriod: 72,
      change: "+5%",
      isPositive: true,
    },
    monthlyRevenue: {
      value: 38459,
      previousPeriod: 34339,
      change: "+12%",
      isPositive: true,
    },
    activeClients: {
      value: 186,
      previousPeriod: 190,
      change: "-2%",
      isPositive: false,
    },
  },

  occupancyChart: {
    daily: [
      { name: "Mon", value: 68 },
      { name: "Tue", value: 78 },
      { name: "Wed", value: 85 },
      { name: "Thu", value: 82 },
      { name: "Fri", value: 75 },
      { name: "Sat", value: 60 },
      { name: "Sun", value: 55 },
    ],
    weekly: [
      { name: "Week 1", value: 62 },
      { name: "Week 2", value: 71 },
      { name: "Week 3", value: 80 },
      { name: "Week 4", value: 76 },
    ],
    monthly: [
      { name: "Jan", value: 65 },
      { name: "Feb", value: 70 },
      { name: "Mar", value: 72 },
      { name: "Apr", value: 75 },
      { name: "May", value: 82 },
      { name: "Jun", value: 76 },
    ],
  },

  revenueChart: {
    data: [
      { name: "Apr", value: 18000 },
      { name: "May", value: 22000 },
      { name: "Jun", value: 24000 },
      { name: "Jul", value: 29000 },
      { name: "Aug", value: 27000 },
      { name: "Sep", value: 25000 },
    ],
  },

  quickActions: [
    {
      id: 1,
      label: "New Booking",
      actionType: "new-booking",
    },
    {
      id: 2,
      label: "Send Notifications",
      actionType: "send-notifications",
    },
    {
      id: 3,
      label: "Add New Space",
      actionType: "add-space",
    },
    {
      id: 4,
      label: "Add Play Service",
      actionType: "add-play-service",
    },
  ],

  todaysBookings: [
    {
      id: 1,
      spaceName: "Conference Room A",
      client: {
        name: "Acme Corp",
        initials: "AC",
      },
      startTime: "2024-01-15T09:00:00Z",
      endTime: "2024-01-15T11:30:00Z",
      status: "Active",
    },
    {
      id: 2,
      spaceName: "Creative Studio",
      client: {
        name: "Design Hub",
        initials: "DH",
      },
      startTime: "2024-01-15T10:30:00Z",
      endTime: "2024-01-15T15:00:00Z",
      status: "Active",
    },
    {
      id: 3,
      spaceName: "Meeting Room B",
      client: {
        name: "Tech Innovators",
        initials: "TI",
      },
      startTime: "2024-01-15T13:00:00Z",
      endTime: "2024-01-15T14:30:00Z",
      status: "Active",
    },
    {
      id: 4,
      spaceName: "Executive Boardroom",
      client: {
        name: "Finance Pro",
        initials: "FP",
      },
      startTime: "2024-01-15T15:00:00Z",
      endTime: "2024-01-15T17:00:00Z",
      status: "Upcoming",
    },
  ],

  availableMonths: ["Jan 2024", "Feb 2024", "Mar 2024", "Apr 2024"],

  notificationCount: 3,

  currentDate: "2024-01-15T00:00:00Z",
};
